(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fascino-progress", [], factory);
	else if(typeof exports === 'object')
		exports["fascino-progress"] = factory();
	else
		root["fascino-progress"] = factory();
})(self, () => {
return 